import * as React from 'react';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import StyledAccordionFilterContainer from 'flow-doctor-lib/components/filters/StyledAccordionFilterContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartDebugEnrollmentFilterRenderer = ({
  debugFilterBranch,
  filterBranch,
  debugDisplayMode,
  filterWidthType,
  objectTypeId,
  condensed = false,
  bordered = true
}) => {
  return /*#__PURE__*/_jsx(StyledAccordionFilterContainer, {
    condensed: condensed,
    padded: false,
    children: /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
      objectTypeId: objectTypeId,
      debugOptions: {
        filterBranch: debugFilterBranch,
        displayMode: debugDisplayMode
      },
      filterBranch: filterBranch,
      filterWidthType: filterWidthType,
      bordered: bordered,
      topLevel: true
    })
  });
};
export default WalmartDebugEnrollmentFilterRenderer;